import {
  text,
  headline,
  field,
  button,
  spacer,
  voucher,
} from '@components/Widgets/_contentItems/all'
import themes from '@components/Widgets/Templates/Themes/all'
import { settings, styling } from '@components/Widgets/Templates/_base'
import { type, position } from '@meta/widget/options.js'
import { tag, typeTag } from '@meta/widget/templates'

const info = {
  name: 'Subtle Discount Code',
  templateID: '6',
  description: 'Provide users with a discreet yet effective way to save with the "Subtle Discount Code" widget. This tool offers a gentle nudge towards making a purchase by revealing a discount code upon interaction.',
  tags: [typeTag.FLYOUT, tag.LEAD_GENERATION, tag.COUPONS_OFFERS],
}

const json = {
  id: 7527811,
  templateID: info.templateID,
  type: type.COLUMN,
  name: info.name,
  theme:themes.MONOCHROME,
  active: true,
  settings: (() => {
    const customSettings = { ...settings }
    customSettings.position = position.CENTER
    customSettings.ribbonColor = '#FFFFFF'
    customSettings.ribbonBgColor = '#000000'
    customSettings.animation = 'slide'
    return customSettings
  })(),
  styling: (() => {
    return { ...styling }
  })(),
  steps: [
    {
      id: 'q7i8h34',
      contentItems: [
        (() => {
          const customText = JSON.parse(JSON.stringify(text))
          customText.content.text = 'WELL, HELLO THERE! :)'
          Object.assign(customText.styling, {
            color: 'rgba(0, 0, 0, 1)',
            fontSize: '14px',
            textAlign: 'center',
            fontFamily: 'Roboto',
            fontWeight: '400',
          })
          return customText
        })(),
        (() => {
          const customHeadline = JSON.parse(JSON.stringify(headline))
          customHeadline.content.text = 'Get 10% OFF your first purchase'
          Object.assign(customHeadline.styling, {
            color: 'rgba(0, 0, 0, 1)',
            fontSize: '26px',
            textAlign: 'left',
            fontFamily: 'Roboto Slab',
            fontWeight: 'bold',
          })
          return customHeadline
        })(),
        (() => {
          const customText = JSON.parse(JSON.stringify(text))
          customText.content.text = 'Plus, be the first to know about sales, new arrivals and more.'
          Object.assign(customText.styling, {
            color: 'rgba(0, 0, 0, 1)',
            fontSize: '14px',
            textAlign: 'left',
            fontFamily: 'Roboto',
            fontWeight: '400',
          })
          return customText
        })(),
        (() => {
          const customField = JSON.parse(JSON.stringify(field))
          customField.content.placeholder = 'Your Email Address'
          Object.assign(customField.styling, {
            color: 'rgba(65, 65, 65, 1)',
            fontSize: '14px',
            textAlign: 'left',
            fontFamily: 'Roboto',
            fontWeight: '400',
            borderColor: 'rgba(81, 81, 81, 1)',
            borderWidth: '1px',
            borderRadius: '0px',
            backgroundColor: 'rgba(254, 254, 254, 1)',
          })
          customField.settings.type = 'email'
          customField.settings.label = 'Email address'
          customField.settings.required = true
          return customField
        })(),
        (() => {
          const customButton = JSON.parse(JSON.stringify(button))
          customButton.content.text = 'Get my 10% OFF'
          Object.assign(customButton.styling, {
            color: 'rgba(254, 254, 254, 1)',
            fontSize: '16px',
            fontFamily: 'Roboto',
            fontWeight: '400',
            borderColor: 'rgba(3, 3, 3, 1)',
            borderWidth: '2px',
            borderRadius: '4px',
            justifyContent: 'center',
            backgroundColor: 'rgba(3, 3, 3, 1)',
          })
          customButton.settings.action = 'next'
          customButton.settings.backBtn = false
          return customButton
        })(),
      ],
    },
    {
      id: '0al9pkp',
      contentItems: [
        (() => {
          const customSpacer = JSON.parse(JSON.stringify(spacer))
          customSpacer.styling.padding = '20px'
          return customSpacer
        })(),
        (() => {
          const customHeadline = JSON.parse(JSON.stringify(headline))
          customHeadline.content.text = 'Congratulations!'
          Object.assign(customHeadline.styling, {
            color: 'rgb(24, 23, 26)',
            fontSize: '26px',
            textAlign: 'left',
            fontFamily: 'Roboto Slab',
            fontWeight: 'bold',
          })
          return customHeadline
        })(),
        (() => {
          const customSpacer = JSON.parse(JSON.stringify(spacer))
          customSpacer.styling.padding = '8px'
          return customSpacer
        })(),
        (() => {
          const customText = JSON.parse(JSON.stringify(text))
          customText.content.text = 'Use the following code on your next order:'
          Object.assign(customText.styling, {
            color: 'rgb(24,23,26)',
            fontSize: '14px',
            textAlign: 'center',
            fontFamily: 'Roboto',
            fontWeight: '400',
          })
          return customText
        })(),
        (() => {
          const customVoucher = JSON.parse(JSON.stringify(voucher))
          customVoucher.content.text = 'VOUCHER CODE'
          Object.assign(customVoucher.styling, {
            color: 'rgb(24, 23, 26)',
            fontSize: '22px',
            textAlign: 'center',
            fontFamily: 'Roboto',
          })
          return customVoucher
        })(),
        (() => {
          const customButton = JSON.parse(JSON.stringify(button))
          customButton.content.text = 'Continue Shopping'
          Object.assign(customButton.styling, {
            color: 'rgba(254, 254, 254, 1)',
            fontSize: '16px',
            fontFamily: 'Roboto',
            fontWeight: '400',
            borderColor: 'rgba(3, 3, 3, 1)',
            borderWidth: '2px',
            borderRadius: '4px',
            justifyContent: 'center',
            backgroundColor: 'rgba(3, 3, 3, 1)',
          })
          customButton.settings.action = 'close'
          customButton.settings.backBtn = false
          return customButton
        })(),
      ],
    },
  ],
}

export { json, info }
